import { Identification, ShipToIdentification } from '@next/core-lib/user';

export function getCurrentKvkNumber(identifications: Identification[]): string | undefined {
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

  return identifications.find(
    (identification) =>
      identification.name === ShipToIdentification.BUP002 &&
      identification.validFrom.slice(0, 10) <= today &&
      today <= identification.validTo.slice(0, 10),
  )?.value;
}
